import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class PestControl extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
          Pest Control
        </h2>
        <p>
          You may find the perfect environment you created for your plants is also perfect for bugs. Monitor your plants closely and research any bugs you find in your marijuana for specific post control options. A few common pest control options include the following.
        </p>
        <h3>   
          Yellow Sticky Traps
        </h3>
        <p>
          <a target="_blank" href="https://www.amazon.com/gp/product/B01I9KUKLQ/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01I9KUKLQ&linkCode=as2&tag=blacksquare05-20&linkId=2af15e0acb7487ae87f21f3fad7da895">Dual-Sided Yellow Sticky Traps</a><img src="//ir-na.amazon-adsystem.com/e/ir?t=blacksquare05-20&l=am2&o=1&a=B01I9KUKLQ" width="1" height="1" alt="" className="amazon__pixel" /> are cheap and easy to use. Install them close to the base of your plants and space them out evenly in your grow space to catch small bugs such as aphids. 
        </p>
        <h3>
          Sand
        </h3>
        <p>
          A thin layer of sand on top of your soil can prevent bugs that lay their eggs in your soil such as aphids from infesting. This can mess with the composition of your soil, so should be used with caution. 
        </p>
        <h3>
          Lady Bugs
        </h3>
        <p>
          <a target="_blank" href="https://www.amazon.com/gp/product/B00533KOIC/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00533KOIC&linkCode=as2&tag=blacksquare05-20&linkId=340b4ad8b4efbc0f6c96d65c4e777424">Live Ladybugs</a><img src="//ir-na.amazon-adsystem.com/e/ir?t=blacksquare05-20&l=am2&o=1&a=B00533KOIC" width="1" height="1" alt="" className="amazon__pixel" /> are friendly to marijuana and eat many of the bugs that aren’t. You can buy them by the hundreds or thousands from many grow shops. Ideal for outdoor grow spaces, you should be careful about introducing them into your home. If you use this method, keep an eye out for dead ladybugs in your final crop. 
        </p>
        <div className="guide__shopping-list">
          <h3>Shopping List</h3>

          <iframe className="amazon__iframe" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=blacksquare05-20&marketplace=amazon&region=US&placement=B01I9KUKLQ&asins=B01I9KUKLQ&linkId=9688a068a1d9f90b61eeef6d7ba4f318&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff">
          </iframe>

          <iframe className="amazon__iframe" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=blacksquare05-20&marketplace=amazon&region=US&placement=B00533KOIC&asins=B00533KOIC&linkId=8014cd55a9fe7422cce148834b103d35&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff">
          </iframe>

        </div>
        <GuideButton slugTo="acquiring-seeds" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/one_pest_control.js